export default __webpack_public_path__ + "static/ak-cached/24h/media/checkmark-white.df95c52f.svg";